'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ignoreErrorMessagePatterns = [
// Ignore usage logging errors
/usage-logging\/v1\/log\/hublytics-multi/i,
// Ignore auth redirects
/.+Aborting: redirection in progress.+/i,
// Ignore presence timeouts
/.+Request for https:\/\/api.hubspot.com\/messages\/v2\/presence\/(heartbeat|offline|online).+failed with status 0.+/i,
// Ignore meetings link 404's from the communicator
/.+Request for https:\/\/api.hubspot.com\/meetings\/v1\/link.+failed with status 404.+/i];

var setNewRelicErrorHandler = exports.setNewRelicErrorHandler = function setNewRelicErrorHandler() {
  if (!window.newrelic) return;

  window.newrelic.setErrorHandler(function (error) {
    return ignoreErrorMessagePatterns.some(function (pattern) {
      return pattern.test(error.message);
    });
  });
};


//////////////////
// WEBPACK FOOTER
// ./js/error-reporting/lib/setNewRelicErrorHandler.js
// module id = 1229
// module chunks = 3